export default "__VITE_PUBLIC_ASSET__5fcf9409__"